
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import IsForm from "@/components/forms/IsForm.vue";
import {IsEntity} from "@/entity/IsEntity";
import DosyaEsasNumarasi from "@/components/inputs/DosyaEsasNumarasi.vue";
import Dates from "@/components/inputs/Dates.vue";
import IsInfo from "@/components/infos/IsInfo.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import EtkinlikForm from "@/components/forms/EtkinlikForm.vue";
import PersonelPicker from "@/components/pickers/PersonelPicker.vue";
import {ajandaRotasi, takipKartiYolu} from "@/helpers/AjandaGecisHelper";

interface Options {
  sortBy: string[];
  sortDesc: boolean[];
  page: number;
  itemsPerPage: number;
}

@Component({
  components: {PersonelPicker, EtkinlikForm, IsInfo, Dates, DosyaEsasNumarasi, IsForm, DeleteDialog, FormDialog}
})
export default class IsList extends Mixins(SimpleInputMixin) {
  @Prop() takip!: TakipEntity;
  @Prop() takipModu!: boolean | string;
  // DEV-1511: Ajanda ekranı, Takip Kartından gelinen takibin id'sini buradan
  // verir. `takip` prop'undan farkı: liste takip moduna geçmez (Kart No /
  // Dosya Numarası sütunları ve satırdaki "Takip Kartına Git" butonu kalır),
  // yalnızca sorgu o takiple sınırlanır.
  @Prop() takipBaglamiId!: number | string;
  @Ref('isForm') readonly isForm!: IsForm;

  localValue!: Array<IsEntity>;
  showFilter: boolean = false;
  isFiltered = false;
  activeTab = 0;
  loading = false;
  totalRecordCount = 0; // API'den dönen toplam kayıt sayısı

  // Yeni API formatı için ayrı array'ler
  devamEdenIslerData: IsEntity[] = [];
  sureGecenIslerData: IsEntity[] = [];
  tamamlananIslerData: IsEntity[] = [];

  // Badge'ler için toplam sayılar
  groupCounts = {
    devam_eden_isler: 0,
    suresi_gecen_isler: 0,
    tamamlanan_isler: 0
  };

  groupLastPages: any = {
    devam_eden_isler: 0,
    suresi_gecen_isler: 0,
    tamamlanan_isler: 0
  };

  filters: any = {
    dosyaEsasNo: null,
    isim: null,
    atanan: null,
    durum: null,
    baslangicTarihi: null,
    bitisTarihi: null
  }

  durumOptions = [
    {text: 'Devam Eden İşler', value: 'devam_eden_isler'},
    {text: 'Süresi Geçen İşler', value: 'suresi_gecen_isler'},
    {text: 'Tamamlanan İşler', value: 'tamamlanan_isler'}
  ];
  options: Options = { sortBy: [''], sortDesc: [true], page: 1, itemsPerPage: 20 };
  itemsLenght = 0;
  headers = [
    {text: "Tamamlandı Mı", value: "tamamlandi_mi", width: 50},
    {text: "Favori", width: 50, sortable: true, value: "favori_mi"},
    {text: "İş No", width: 50, sortable: true, value: "id"},
    {text: "Tarih", value: "tarih"},
    {text: "İşin Adı", value: "isim"},
    {text: "Kart No", value: "takip_id"},
    {text: "Dosya Numarası", value: "dosya_esas_no"},
    {text: "Atanan Kişi", value: "atanan_isim"},
    {text: "İşlemler", value: "actions", width: 180, align: "center", sortable: false}
  ];

  get isTakipModu() {
    return this.takipModu || this.takipModu === "";
  }

  get takipId() {
    // Takip modunda takip prop'undan, Ajandada URL'den gelen bağlamdan.
    // Tek getter olduğu için filtreleme, Excel çıktısı ve "İş Ekle"
    // formundaki takip bağı kendiliğinden aynı takibe hizalanır.
    return this.takip?.id ?? this.takipBaglamiId;
  }

  get gununTarihi() {
    let bugun = new Date();
    return bugun.toLocaleDateString('tr-TR', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'});
  }

  get hasActiveFilters(): boolean {
    return Object.values(this.filters).some(value => value !== null && value !== '');
  }

  get tamamlanmisIsler(): IsEntity[] {
    // Eğer yeni API formatından veri geldiyse, onu kullan
    if (this.tamamlananIslerData.length > 0) {
      return this.tamamlananIslerData;
    }
    // Eski format için fallback
    return this.localValue ? this.localValue.filter(item => item.tamamlandi_mi) : [];
  }

  get tamamlanmamisIsler(): IsEntity[] {
    // Eğer yeni API formatından veri geldiyse, onu kullan
    if (this.devamEdenIslerData.length > 0) {
      return this.devamEdenIslerData;
    }
    // Eski format için fallback
    return this.localValue ? this.localValue.filter(item => !item.tamamlandi_mi && !this.isOverdue(item)) : [];
  }

  // YENİ: Günü geçmiş işler (tarih < bugün ve tamamlanmamış)
  get gunuGecmisIsler(): IsEntity[] {
    // Eğer yeni API formatından veri geldiyse, onu kullan
    if (this.sureGecenIslerData.length > 0) {
      return this.sureGecenIslerData;
    }
    // Eski format için fallback
    return this.localValue ? this.localValue.filter(i => this.isOverdue(i)) : [];
  }

  get tamamlanmisIslerCount(): number {
    return this.groupCounts.tamamlanan_isler;
  }

  get tamamlanmamisIslerCount(): number {
    return this.groupCounts.devam_eden_isler;
  }

  // sayaç
  get gunuGecmisIslerCount(): number {
    return this.groupCounts.suresi_gecen_isler;
  }

  //bugünün 00:00'ı
  get todayStart(): Date {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  // güvenli tarih parse
  private toDate(val: any): Date | null {
    if (!val) return null;
    const d = new Date(val);
    if (!isNaN(d.getTime())) return d;
    if (typeof val === 'string') {
      const m = val.match(/^(\d{2})[./-](\d{2})[./-](\d{4})$/);
      if (m) {
        const [_, dd, mm, yyyy] = m;
        const fixed = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        return isNaN(fixed.getTime()) ? null : fixed;
      }
    }
    return null;
  }

  // overdue kontrolü
  private isOverdue(item: IsEntity): boolean {
    const d = this.toDate(item.tarih);
    return !!d && d.getTime() < this.todayStart.getTime() && !item.tamamlandi_mi;
  }

  // DEV-1511: Bu takibin işlerini Ajanda ekranında aç. Takibin izi URL ile
  // taşındığı için ajanda o takibe filtreli açılır ve sayfa yenilense de korunur.
  ajandayaGit() {
    this.$router.push(ajandaRotasi(this.takipId, this.takip?.dosya_esas_no));
  }

  // DEV-1511: İşin bağlı olduğu Takip Kartını aç. Açılmamış takipler
  // takip-ekle sihirbazına gider (bkz. AjandaGecisHelper).
  takibeGit(item: IsEntity) {
    const yol = takipKartiYolu(item.takip_id, item.takip_durumu);
    if (yol) {
      this.$router.push(yol);
    }
  }

  onFavoriChange(item: IsEntity) {
    item.favori_mi = !item.favori_mi;
    this.$http.put("/api/v1/is/" + item.id, item).then(() => {
      this.load();
    });
  }

  onDurumChange(item: IsEntity) {
    item.tamamlandi_mi = !item.tamamlandi_mi;
    this.$http.put("/api/v1/is/" + item.id, item).then(() => {
      this.load();
    });
  }

  mounted() {
    if (this.isTakipModu) {
      this.headers.splice(5, 1);
      // Takip modundayken hemen veri yükle
      this.search();
    } else {
      this.search();
    }
  }

  search() {
    this.loading = true;
    this.isFiltered = Object.values(this.filters).some(value => value !== null && value !== '');
    this.load();
  }

  resetFilters() {
    this.filters = {
      dosyaEsasNo: null,
      isim: null,
      atanan: null,
      durum: null,
      baslangicTarihi: null,
      bitisTarihi: null
    };

    this.load();
  }

  @Watch('options', { deep: true })
  onOptionsChange(newVal: Options, oldVal: Options) {
    if (newVal.page !== oldVal.page ||
        newVal.sortBy.toString() !== oldVal.sortBy.toString() ||
        newVal.sortDesc.toString() !== oldVal.sortDesc.toString() ||
        newVal.itemsPerPage !== oldVal.itemsPerPage) {
      this.load();
    }
  }

  @Watch('takip')
  onTakipChange() {
    if (this.isTakipModu && this.takip?.id) {
      this.search();
    }
  }

  @Watch('takipId')
  onTakipIdChange() {
    if (this.isTakipModu && this.takipId) {
      this.search();
    }
  }

  // DEV-1511: Ajandada bağlam değişince (takibe göre filtrele / bağlamı
  // temizle) listeyi yeniden yükle. Takip modunda bu prop kullanılmadığı
  // için oradaki akış etkilenmez.
  @Watch('takipBaglamiId')
  onTakipBaglamiIdChange() {
    if (!this.isTakipModu) {
      this.search();
    }
  }

  exportToExcel() {
    this.loading = true;

    // Filter parametrelerini hazırla
    let payload: any = {};

    Object.keys(this.filters).forEach(key => {
      if (this.filters[key]) {
        payload[key] = this.filters[key];
      }
    });

    // Takip ID varsa ekle
    if (this.takipId) {
      payload.takip = this.takipId;
    }

    // POST isteği ile Excel al
    // NOT: Axios interceptor response.data döndürüyor, bu yüzden response direkt blob
    this.$http.post('/api/v1/is/excel', payload, {
      responseType: 'blob' // Excel dosyası için blob response
    })
        .then((blob: any) => {
          // Response interceptor zaten response.data döndürüyor, blob direkt geliyor
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // Dosya adı (header'lara erişemiyoruz çünkü interceptor unwrap ediyor)
          let fileName = 'İş_Listesi_' + new Date().getTime() + '.xls';

          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          // Cleanup
          link.remove();
          window.URL.revokeObjectURL(url);

          this.loading = false;

          this.$store.dispatch('snackbar/showSnackbar', {
            text: 'Excel dosyası başarıyla indirildi.',
            color: 'success'
          });
        })
        .catch(error => {
          console.error('Excel indirme hatası:', error);
          this.loading = false;

          this.$store.dispatch('snackbar/showSnackbar', {
            text: 'Excel dosyası indirilemedi.',
            color: 'error'
          });
        });
  }

  load() {
    this.loading = true;
    const { sortBy, sortDesc, page, itemsPerPage } = this.options;

    // Takip modundayken takip ID yoksa yükleme yapmayalım
    if (this.isTakipModu && !this.takipId) {
      this.loading = false;
      return;
    }

    this.$http.get("/api/v1/is/filter", {
      params: {
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
        page: page,
        paginate: itemsPerPage,
        ...(this.isFiltered && this.filters),
        ...(this.takipId && { takip: this.takipId }),
      }
    }).then((response: any) => {
      // YENİ FORMAT: response.data içinde üç ayrı array var
      if (response.data && response.data.devam_eden_isler !== undefined) {
          // Items arraylerini al
          this.devamEdenIslerData = response.data.devam_eden_isler.items || [];
          this.sureGecenIslerData = response.data.suresi_gecen_isler.items || [];
          this.tamamlananIslerData = response.data.tamamlanan_isler.items || [];

          // Group counts'u response data içindeki total alanlarından al
          this.groupCounts = {
              devam_eden_isler: response.data.devam_eden_isler.total || 0,
              suresi_gecen_isler: response.data.suresi_gecen_isler.total || 0,
              tamamlanan_isler: response.data.tamamlanan_isler.total || 0
          };

          this.groupLastPages = {
            devam_eden_isler: response.data.devam_eden_isler.last_page || 0,
            suresi_gecen_isler: response.data.suresi_gecen_isler.last_page || 0,
            tamamlanan_isler: response.data.tamamlanan_isler.last_page || 0
          };

        // localValue'yi tüm verilerin birleşimi olarak set et (Excel export vb. için)
        this.localValue = [
          ...this.devamEdenIslerData,
          ...this.sureGecenIslerData,
          ...this.tamamlananIslerData
        ];
        
        // Bu eski totalRecordCount yerine artık her tab için groupCounts kullanıyoruz
        this.totalRecordCount = this.groupCounts.devam_eden_isler + this.groupCounts.suresi_gecen_isler + this.groupCounts.tamamlanan_isler;

        this.itemsLenght = this.localValue.length;
      }
      // ESKİ FORMAT: Array olarak direkt dönüyor
      else if (Array.isArray(response.data)) {
        this.localValue = response.data;
        this.itemsLenght = response.data.length;
        this.totalRecordCount = response.total || response.data.length;

        // Yeni format array'lerini sıfırla
        this.devamEdenIslerData = [];
        this.sureGecenIslerData = [];
        this.tamamlananIslerData = [];

        // Group counts'u manuel hesapla (eski format için)
        const tamamlanan = this.localValue.filter(item => item.tamamlandi_mi);
        const gunuGecmis = this.localValue.filter(item => this.isOverdue(item));
        const devamEden = this.localValue.filter(item => !item.tamamlandi_mi && !this.isOverdue(item));

        this.groupCounts = {
          devam_eden_isler: devamEden.length,
          suresi_gecen_isler: gunuGecmis.length,
          tamamlanan_isler: tamamlanan.length
        };
      }
      // ESKİ FORMAT: Paginated response (response.data.data)
      else if (response.data && Array.isArray(response.data.data)) {
        this.localValue = response.data.data;
        this.itemsLenght = response.data.total || response.data.data.length;

        // API'den total değeri geliyorsa onu kullan, yoksa data.length kullan
        if (response.data.total !== undefined) {
          this.totalRecordCount = response.data.total;
        } else if (response.data.count !== undefined) {
          this.totalRecordCount = response.data.count;
        } else {
          this.getTotalCount();
          this.totalRecordCount = response.data.data.length;
        }

        // Yeni format array'lerini sıfırla
        this.devamEdenIslerData = [];
        this.sureGecenIslerData = [];
        this.tamamlananIslerData = [];

        // Group counts'u manuel hesapla (eski format için)
        const tamamlanan = this.localValue.filter(item => item.tamamlandi_mi);
        const gunuGecmis = this.localValue.filter(item => this.isOverdue(item));
        const devamEden = this.localValue.filter(item => !item.tamamlandi_mi && !this.isOverdue(item));

        this.groupCounts = {
          devam_eden_isler: devamEden.length,
          suresi_gecen_isler: gunuGecmis.length,
          tamamlanan_isler: tamamlanan.length
        };
      }
      // HATA: Beklenmeyen format
      else {
        this.localValue = [];
        this.itemsLenght = 0;
        this.totalRecordCount = 0;
        this.devamEdenIslerData = [];
        this.sureGecenIslerData = [];
        this.tamamlananIslerData = [];
        this.groupCounts = {
          devam_eden_isler: 0,
          suresi_gecen_isler: 0,
          tamamlanan_isler: 0
        };
        this.groupLastPages = {
          devam_eden_isler: 0,
          suresi_gecen_isler: 0,
          tamamlanan_isler: 0
        };
      }

      this.$emit('load');
      this.loading = false;
    }).catch(error => {
      console.error('İş listesi yüklenirken hata oluştu:', error);
      this.loading = false;
    });
  }

  // Toplam kayıt sayısını almak için ayrı method
  getTotalCount() {
    let params: any = {
      count_only: true, // Sadece sayı döndürmesi için
      ...(this.isFiltered && this.filters),
      ...(this.takipId && { takip: this.takipId }),
    };

    this.$http.get("/api/v1/is/filter", { params })
        .then((response: any) => {
          if (response.data && response.data.total !== undefined) {
            this.totalRecordCount = response.data.total;
          }
        })
        .catch(error => {
          console.error('Toplam kayıt sayısı alınırken hata oluştu:', error);
        });
  }

  getServerItemsLength(group: string) {
    return (this.groupCounts as any)[group] || 0;
  }
}
